import environment from '../../../common/environment';
import { SearchClickthroughRequest } from '../interfaces/search.interface';

export function postSearchClickthrough(requestBody: SearchClickthroughRequest) {
  return fetch(`${environment().searchServiceUrl}/clickthrough`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
    keepalive: true,
  });
}
